export default __webpack_public_path__ + "static/media/slide-1.76593f4b.png";